import * as React from "react";
const SvgIconPlay = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("polygon", { points: "5 3 19 12 5 21 5 3" }));
export { SvgIconPlay as ReactComponent };
